import { IColoredUser, UserI } from "@services/getUsers";
import {
  ActionBaseUser,
  ActionEditUserColor,
  ActionSetUsers,
  ActionTypesUsersE,
} from "./actionTypes";

export function setUsers(users: UserI[]): ActionSetUsers {
  return {
    type: ActionTypesUsersE.SET_USERS,
    payload: { users },
  };
}

export function editUserColor(payload: IColoredUser): ActionEditUserColor {
  return {
    type: ActionTypesUsersE.EDIT_USER_COLOR,
    payload,
  };
}

export function clearUsers(): ActionBaseUser {
  return {
    type: ActionTypesUsersE.CLEAR_USERS,
  };
}
